import { defineMessages } from 'react-intl'

const translations = defineMessages({
  updateMachine: {
    defaultMessage: 'Update Machine',
    id: 'msp.account.machine_display.update_machine.label'
  },
  updateMachineTitle: {
    defaultMessage: 'Update Machine',
    id: 'msp.account.machine_display.update_machine.title'
  },
  updateMachineConfirm: {
    defaultMessage: 'Save changes',
    id: 'msp.account.machine_display.update_machine.save_changes'
  },
  updateMachineCancel: {
    defaultMessage: 'Cancel',
    id: 'msp.account.machine_display.update_machine.cancel'
  },
  formFieldSerialNo: {
    defaultMessage: 'Serial number (18 digits)',
    id: 'msp.account.machine_display.update_machine_form.machine_serial_no'
  },
  formFieldSerialNoError: {
    defaultMessage: 'Please enter the serial number.',
    id: 'msp.account.machine_display.update_machine_form.error.required_machine_serial_no'
  },
  formFieldSerialNoPatternError: {
    defaultMessage:
      'Please enter a valid serial number (e.g 6000501XXXXXXX0001 or 6000502"XXXXXXX0001).',
    id: 'msp.account.machine_display.update_machine_form.error.pattern_serial_no'
  },
  formFieldPurchaseDate: {
    defaultMessage: 'Purchase date',
    id: 'msp.account.machine_display.update_machine_form.purchase_date'
  },
  formFieldPurchaseDatePlaceholder: {
    defaultMessage: 'DD.MM.YYYY',
    id: 'msp.account.machine_display.update_machine_form.purchase_date_placeholder'
  },
  formFieldPurchaseDateError: {
    defaultMessage: 'Please enter the purchase date.',
    id: 'msp.account.machine_display.update_machine_form.error.required_purchase_date'
  },
  formFieldPurchaseDatePatternError: {
    defaultMessage:
      'Please enter the date in the following pattern (DD/MM/YYYY) or (DD.MM.YYYY).',
    id: 'msp.account.machine_display.update_machine_form.error.pattern_purchase_date'
  }
})

export default translations
